import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import { Trans, useTranslation } from "@coworker/locales";
import profilePreferences from "@coworker/enums/profilePreferences";
import Instructions from "../../Instructions";
import { useInputPopup } from "../../InputPopup";
import { Article } from "../types/article";
import { Text } from "../Atoms/Text";
import { Overlay } from "../styles/styles";
import { useUpdateArticle } from "../hooks/useUpdateArticle";
import FixaImage from "@coworker/apprestructured/src/shared/wrappers/FixaImage/FixaImage";
import DateStampNew from "@coworker/app/src/assets/images/DateStampNew.png";

const { DISABLE_POPUPS_DATE_STAMP } = profilePreferences;

interface DateStampProps {
  article: Article;
  value: string;
}

export const DateStamp = ({ article, value }: DateStampProps) => {
  const { t } = useTranslation();
  const { getInput } = useInputPopup();
  const updateArticle = useUpdateArticle(article.id);

  const getDateStamp = async () => {
    const response = await getInput("number", {
      value,
      bigTitle: <Trans>dateStampString</Trans>,
      instruction: (
        <Instructions
          title={<Trans>whereCanIfindString</Trans>}
          text={
            <Overlay minHeight="133px">
              <FixaImage src={DateStampNew} />
            </Overlay>
          }
          type={DISABLE_POPUPS_DATE_STAMP}
        />
      ),
    });
    if (response) {
      try {
        await updateArticle.mutateAsync({ dateStamp: response });
      } catch {
        alert(t("searchErrorString"));
      }
    }
  };

  const addOnContent = value ? <Text text={value} grey /> : "";

  return (
    <FixaListViewItem
      title={t("dateStampString")}
      addOn={addOnContent}
      control={"navigational"}
      controlIcon={"chevronRightSmall"}
      onClick={getDateStamp}
      emphasised
      inset
    />
  );
};
